import script from "./AgreementIpBlockView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementIpBlockView.vue?vue&type=script&setup=true&lang=js"

import "./AgreementIpBlockView.vue?vue&type=style&index=0&id=537af4ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537af4ca"]])

export default __exports__